import React from 'react'
import injectSheet from 'react-jss'
import styles from './page-head.styles'
import classNames from 'classnames'

const PageHead = ({ classes, className, ...props }) => (
  <div className={classNames(classes.container, className)} {...props} />
)

export default injectSheet(styles)(PageHead)
